import React, { Component } from 'react';
import Select from 'react-select';
import services from './data';

class BankList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      selectedBank: null,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    services
      .getMappedBanks()
      .then((response) => {
        const tmp = response.data.data;
        const options = tmp.map((bank) => ({
          value: bank.bunk_bank_uuid,
          label: bank.name,
        }));
        this.setState({ options });
        if (options.length > 0) {
          this.handleChange(options[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleChange(selectedOption) {
    this.setState({ selectedBank: selectedOption });
    this.props.handleBankChange(selectedOption);
  }

  handleReset() {
    const { options } = this.state;
    if (options.length > 0) {
      this.handleChange(options[0]);
    }
  }

  render() {
    const { options, selectedBank } = this.state;
    return (
      <Select
        onChange={this.handleChange}
        isClearable={true}
        options={options}
        className="select-box-container"
        classNamePrefix="raw-select"
        name="bank"
        placeholder="Select bank"
        value={selectedBank}
        isDisabled={this.props.disabled || false}
      />
    );
  }
}

export { BankList };
